module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-laurel-winter-film-fest.4bac243.png";